import Vue from "vue";
import modalComponent from "./TreatmentTypeModal.vue";
import { getCategory } from "@/MedExpressJS/Categories";

export default class ModalInitialiser {
  readonly component: Vue;

  public constructor() {
    const mountingElement = document.getElementById("treatment-type-modal");

    if (!mountingElement) {
      throw new Error("Failed to find treatment type modal mount point");
    }

    const categoryName = mountingElement.getAttribute("data-category");

    if (!categoryName) {
      throw new Error("Cannot find category attribute on #treatment-type-modal element");
    }

    const category = getCategory(categoryName);

    const vueinst = new Vue({
      el: mountingElement,
      render: (createElement) =>
        createElement(modalComponent, {
          props: {
            title: "How can we help?",
            description: "Select a treatment area to get started",
            treatmentOptions: category.treatmentOptions,
            visible: false,
          },
          on: {
            close: this.hideModal.bind(this),
          },
        }),
    });

    this.component = vueinst.$children[0];
  }

  public showModal(): void {
    this.component.$props["visible"] = true;
  }

  public hideModal(): void {
    this.component.$props["visible"] = false;
  }
}

window.addEventListener("DOMContentLoaded", async () => {
  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  (window as any).TreatmentTypeModal = new ModalInitialiser();
});
